// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_at-3";
export var contentContainer = "_at-0";
export var editorContainer = "_at-1";
export var quillInputForm = "_at-2";
export var zoneDivider = "_at-4";